import React from 'react';
import {SmartDateLabel, IconMenu, FormDialog, OverflowTip} from 'components/core';
import {InsertDriveFile, GetApp} from '@material-ui/icons';
import Image from 'material-ui-image';
import {Grid, IconButton, Tooltip} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

const style = makeStyles((theme) => ({
    root: 
    {
        padding: 24
    },
    itemContainer:
    {
        width: '100%'
    },
    item:
    {
        width: '100%',
        height: 56,
        backgroundColor: theme.palette.input.background,
        display: 'flex'
    },
    itemImageContainer:
    {
        flexBasis: 56,
    },
    itemIcon:
    {
        color: theme.palette.text.primary,
        width: 36,
        height: 36,
        margin: 10
    },
    itemMenu:
    {
        flexBasis: 56,
        padding: 4
    },
    itemText: {
        flexGrow: 1,
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        padding: '10px 15px'
    },
    name: 
    {
        color: theme.palette.text.secondary,
        fontWeight: 500,
        float: 'left',
        width: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }
    ,
    detail: 
    {
        color: theme.palette.text.primary,
        fontSize: '12px',
        float: 'left',
        width: '100%'
    }, 
    largeImg: {
        // width: 500,
        // height: 500,
        maxWidth: "60vw",
        maxHeight: "80vh",
        minWidth: 50,
        minHeight: 50,
        padding: 0,
        borderRadius: 8,
        '& img':
        {
            borderRadius: 8
        },
        '&.loading': {
            width: 50,
            height: 50
        }
    }
  }), {name: "RaymanFileList"});

  function TooltipedPicture({file})
  {
     const [loading, setLoading] = React.useState(true);
    const classes = style();
    return <Tooltip placement="left" classes={{tooltip: clsx(classes.largeImg, loading && "loading")}} onClose={() => setLoading(true)}
    title={
        <Image 
        style={{paddingTop: 0, maxWidth: "100%", maxHeight: "100%", width: loading && 50, height: loading && 50}} 
        iconContainerStyle={{transform: 'scale(0.5)'}} 
        imageStyle={{objectFit: "contain", position: "relative", maxWidth: "60vw", maxHeight: "80vh"}} 
        color="transparent" 
        src={file.src} 
        alt={file.fileName}
        onLoad = {() => setLoading(false)}
        onError = {() => setLoading(false)}
        />
    }
  >
    <div className={classes.itemImageContainer}>
        <Image iconContainerStyle={{transform: 'scale(0.5)'}} imageStyle={{objectFit: "cover"}} color="transparent" src={file.src} alt={file.fileName}/>
    </div>
    </Tooltip>
  }

  function EditMenu({file, context, isLocal})
{
    const ctx = React.useContext(context);
    const [open, setOpen] = React.useState(false);
    const [loading, setLoading] = React.useState(false);

    const handleClose = () => {
        setOpen(false);
    }

    const handleOpen = () => {
        setOpen(true);
    }

    const handleConfirm = (data) => {
        if(isLocal)
        {

        }
        else
        {
            setLoading(true);
            ctx.funcs.update(file.fileID, data).then(() => {
                setLoading(false);
                setOpen(false);
            });
        }
    }

    const handleDownload = () => {
        const a = document.createElement("a");
            
        a.href = file.src;
        a.download = file.fileName;
        a.target = "_blank";
        a.click();
        a.remove();
    }

    const handleDelete = () => {
        if(isLocal)
        {

        }
        else
        {
            ctx.funcs.delete(file.fileID);
        }
    }

    let items = [];
    items.push( {
        label: "Renombrar",
        onClick: () => handleOpen()
    });

    if(!isLocal) items.push( {
            label: "Descargar",
            onClick: () => handleDownload()
        });

    items.push( {
            label: "Borrar",
            onClick: () => handleDelete(),
            danger: true
    });
    
    return <>
    <IconMenu items={items} />
    <FormDialog
    open={open}
    onClose={handleClose}
    onConfirm={handleConfirm}
    title="Renombrar archivo"
    subtitle="Introduzca el nuevo nombre para el archivo"
    confirm="Renombrar"
    cancel="Cancelar"
    loading={loading}
    fields={[
        {
        type: "text",
        label: "Nombre",
        id: "fileName",
        placeholder: "",
        mandatory: true,
        value: file.fileName
        }
    ]}
    />
    </>
}


function FileComponent({file, editable, context, isLocal = false, ...props})
{
    const classes = style();

    const handleDownload = () => {
        const a = document.createElement("a");
            
        a.href = file.src;
        a.download = file.fileName;
        a.target = "_blank";
        a.click();
        a.remove();
    }

    return <div className={classes.item}>
        <div className={classes.itemImageContainer}>
            {file.fileType.startsWith("image") ? <TooltipedPicture file={file}/>
            :
            <InsertDriveFile className={classes.itemIcon} />
            }
        </div>
        <div className={classes.itemText}>
            {/* <Grid container direction="column" justify="space-around"> */}
                <OverflowTip value={file.fileName} className={classes.name}>{file.fileName}</OverflowTip>
                <span className={classes.detail}>
                    {isLocal ? "Archivo local"
                    : <SmartDateLabel unformatted datetime={file.uploadDatetime} /> }
                </span>
            {/* </Grid> */}
        </div>
        <div className={classes.itemMenu}>
            { isLocal || editable ? 
                <EditMenu file={file} context={context} isLocal={isLocal}/>
            :
                <IconButton onClick={handleDownload}>
                    <GetApp />
                </IconButton>
            }
        </div>
    </div>
}

function FilesList({context, editable = false, isLocal = false, files = [], ...props})
{
    const ctx = React.useContext(context);
    const classes = style();

    return <Grid container direction="column" spacing={2} className={clsx(classes.root, props.className)}>
        {
        isLocal ? 
            files.map((item, index) => <Grid item key={index} className={classes.itemContainer}><FileComponent file={item} isLocal/></Grid>)
        : 
            ctx.data.array.map((item) => <Grid item key={item.id} className={classes.itemContainer}><FileComponent file={item} editable={editable} context={context}/></Grid>)
        }
    </Grid>
}

export default FilesList;
export {TooltipedPicture, FilesList, FileComponent};